var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6992 2.47705H9.32109L7.81172 1.06299C7.43672 0.687676 6.93047 0.477051 6.39922 0.477051H2.69922C1.59453 0.477051 0.699219 1.37268 0.699219 2.47705V12.4771C0.699219 13.5814 1.59453 14.4771 2.69922 14.4771H14.6992C15.8039 14.4771 16.6992 13.5814 16.6992 12.4771V4.47705C16.6992 3.37393 15.8305 2.47705 14.6992 2.47705ZM15.1992 12.4771C15.1992 12.7528 14.9749 12.9771 14.6992 12.9771H2.69922C2.42353 12.9771 2.19922 12.7528 2.19922 12.4771V2.47705C2.19922 2.2013 2.42353 1.97705 2.69922 1.97705H6.37109C6.50462 1.97705 6.63025 2.02905 6.72453 2.12355L8.69922 3.97705H14.6992C14.9749 3.97705 15.1992 4.2013 15.1992 4.47705V12.4771Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadQuestion);
export default __webpack_public_path__ + "static/media/file-upload-question.3370e3a1183e2e38383eb9d9b23267e1.svg";
export { ForwardRef as ReactComponent };